// extracted by mini-css-extract-plugin
export default {"reviewsContainer":"feefo-reviews__reviewsContainer___1C76F"};